import { configureStore } from "@reduxjs/toolkit";
import stationsReducer from "./stations";
import stationsHourlyReducer from "./stationsHourly";
import stationsDailyReducer from "./stationsDaily";
import stacksReducer from "./stacks";
import soundReducer from "./sound";
import informationReducer from "./information";
import loginReducer from "./login";
import stationsTwelveReducer from "./stationTwelve";
import stationsTwentyFourReducer from "./stationTwentyFour";
import testReducer from "./test";
import leqReducer from "./leq";
import weatherReducer from "./weather";

const store = configureStore({
  reducer: {
    stations: stationsReducer,
    stationsHourly: stationsHourlyReducer,
    stationsTwelve: stationsTwelveReducer,
    stationsTwentyFour: stationsTwentyFourReducer,
    stationsDaily: stationsDailyReducer,
    stacks: stacksReducer,
    sound: soundReducer,
    leq: leqReducer,
    test: testReducer,
    login: loginReducer,
    information: informationReducer,
    weather: weatherReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(),
});

export default store;
